import { render, staticRenderFns } from "./CmgRefresh.vue?vue&type=template&id=a5b8ddac&scoped=true&lang=pug"
import script from "./cmg-refresh.ts?vue&type=script&lang=ts&external"
export * from "./cmg-refresh.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRefresh.vue?vue&type=style&index=0&id=a5b8ddac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b8ddac",
  null
  
)

export default component.exports